/**
 * US metros — mirror of `backend/services/us_metros.py`. Drives
 * `/instructors/:slug` and `/events/:slug` dispatching to city hubs.
 */

export const US_METROS = [
  ['New York', 'NY', 'new-york-ny', ['Manhattan', 'Brooklyn', 'Queens', 'Bronx', 'Staten Island', 'NYC']],
  ['Los Angeles', 'CA', 'los-angeles-ca', ['LA']],
  ['Chicago', 'IL', 'chicago-il', []],
  ['Houston', 'TX', 'houston-tx', []],
  ['Phoenix', 'AZ', 'phoenix-az', []],
  ['Philadelphia', 'PA', 'philadelphia-pa', ['Philly']],
  ['San Antonio', 'TX', 'san-antonio-tx', []],
  ['San Diego', 'CA', 'san-diego-ca', []],
  ['Dallas', 'TX', 'dallas-tx', []],
  ['San Jose', 'CA', 'san-jose-ca', []],
  ['Austin', 'TX', 'austin-tx', []],
  ['Jacksonville', 'FL', 'jacksonville-fl', []],
  ['Fort Worth', 'TX', 'fort-worth-tx', []],
  ['Columbus', 'OH', 'columbus-oh', []],
  ['Indianapolis', 'IN', 'indianapolis-in', []],
  ['Charlotte', 'NC', 'charlotte-nc', []],
  ['San Francisco', 'CA', 'san-francisco-ca', ['SF']],
  ['Seattle', 'WA', 'seattle-wa', []],
  ['Denver', 'CO', 'denver-co', []],
  ['Washington', 'DC', 'washington-dc', ['DC']],
  ['Nashville', 'TN', 'nashville-tn', []],
  ['Oklahoma City', 'OK', 'oklahoma-city-ok', ['OKC']],
  ['El Paso', 'TX', 'el-paso-tx', []],
  ['Boston', 'MA', 'boston-ma', []],
  ['Portland', 'OR', 'portland-or', []],
  ['Las Vegas', 'NV', 'las-vegas-nv', ['Vegas']],
  ['Detroit', 'MI', 'detroit-mi', []],
  ['Memphis', 'TN', 'memphis-tn', []],
  ['Louisville', 'KY', 'louisville-ky', []],
  ['Baltimore', 'MD', 'baltimore-md', []],
  ['Milwaukee', 'WI', 'milwaukee-wi', []],
  ['Albuquerque', 'NM', 'albuquerque-nm', []],
  ['Tucson', 'AZ', 'tucson-az', []],
  ['Fresno', 'CA', 'fresno-ca', []],
  ['Sacramento', 'CA', 'sacramento-ca', []],
  ['Mesa', 'AZ', 'mesa-az', []],
  ['Atlanta', 'GA', 'atlanta-ga', []],
  ['Kansas City', 'MO', 'kansas-city-mo', []],
  ['Colorado Springs', 'CO', 'colorado-springs-co', []],
  ['Miami', 'FL', 'miami-fl', []],
  ['Raleigh', 'NC', 'raleigh-nc', []],
  ['Omaha', 'NE', 'omaha-ne', []],
  ['Long Beach', 'CA', 'long-beach-ca', []],
  ['Virginia Beach', 'VA', 'virginia-beach-va', []],
  ['Oakland', 'CA', 'oakland-ca', []],
  ['Minneapolis', 'MN', 'minneapolis-mn', []],
  ['Tulsa', 'OK', 'tulsa-ok', []],
  ['Arlington', 'TX', 'arlington-tx', []],
  ['Tampa', 'FL', 'tampa-fl', []],
  ['New Orleans', 'LA', 'new-orleans-la', ['NOLA']],
  ['Orlando', 'FL', 'orlando-fl', []],
  ['Pittsburgh', 'PA', 'pittsburgh-pa', []],
  ['St. Louis', 'MO', 'st-louis-mo', ['Saint Louis']],
  ['Cleveland', 'OH', 'cleveland-oh', []],
  ['Cincinnati', 'OH', 'cincinnati-oh', []],
  ['Beverly Hills', 'CA', 'beverly-hills-ca', []],
];

const SLUG_TO = {};
for (const [name, state, slug, aliases] of US_METROS) {
  SLUG_TO[slug] = { name, state, slug, aliases };
}

/** Resolve a city slug like `atlanta-ga` to `{name, state, slug, aliases}` or null. */
export function resolveMetro(input) {
  if (!input || typeof input !== 'string') return null;
  return SLUG_TO[input.trim().toLowerCase()] || null;
}
